import { Heading } from './Heading';
import { spacingClass } from '@/utils/spacing';

/**
 * @param {{ image?: string, imageAlt?: string, title?: string, subtitle?: string, cta?: string, ctaHref?: string, spacing?: string, headingLevel?: number }} props
 */
export function CtaBlock({ image, imageAlt = '', title, subtitle, cta, ctaHref = '#', spacing = 'normal', headingLevel = 2 }) {
  return (
    <section className={'relative px-6 md:px-16 text-center overflow-hidden ' + spacingClass(spacing)}>
      {image && (
        <>
          <img src={image} alt={imageAlt || title || ''} className="absolute inset-0 w-full h-full object-cover -z-10" loading="lazy" decoding="async" />
          <div className="absolute inset-0 bg-black/40 -z-10" />
        </>
      )}
      <div className="max-w-2xl mx-auto">
        {title && <Heading level={headingLevel} className={'font-heading text-h1 font-light mb-5 ' + (image ? 'text-white' : 'text-theme-text')}>{title}</Heading>}
        {subtitle && <p className={'text-body-lg leading-relaxed mb-9 ' + (image ? 'text-white/85' : 'text-theme-text-muted')}>{subtitle}</p>}
        {cta && (
          <a
            href={ctaHref}
            className="inline-flex items-center px-8 py-3.5 rounded-lg bg-theme-accent text-theme-accent-text text-sm font-medium tracking-wide"
          >
            {cta}
          </a>
        )}
      </div>
    </section>
  );
}
